import { AutogenLayoutSettlementControl } from "./autogen/AutogenLayoutSettlementControl";
import {
    ChangeEvent, ClickEvent, DataSourceAction, DataSourceExecutionEvent, Label, LookupModelSearchEvent, Panel, Snackbar,
    Textbox, Toast, ValidationResult
} from "@mcleod/components";
import { CommonDialogs, UserLayoutProvider } from "@mcleod/common";
import { ImageName } from "@mcleod/images";
import { Api, DisplayType, FieldUpdateEvent } from "@mcleod/core";

export class SettlementControl extends AutogenLayoutSettlementControl {

    override onLoad(): void {
    }

    sourcePayrollControlAfterExecution(event: DataSourceExecutionEvent) {
        this.activeRow.addAfterFieldUpdateListener((event: FieldUpdateEvent) => {
            this.buttonUpdateYear.enabled = !this.activeRow.hasChanged();
            if (!this.buttonUpdateYear.enabled) {
                this.buttonUpdateYear.disabledTooltip = "You must save changes before updating the year.";
            }
        });
        this.updateClassDescriptionByFormat(this.activeRow.getString("dir_dep_format", ""));
        if (event.getAction() === DataSourceAction.UPDATE) {
            UserLayoutProvider.refreshSettings(this);
        }
    }

    private updateClassDescriptionByFormat(format: string): void {
        const isAchFormat = format === "A";
        this.textboxDirDepClassDescCCD.visible = isAchFormat;
        this.textboxDirDepClassDescCCD.width = isAchFormat ? "300" : "0";
        this.textboxDirDepClassDescCCD.rowBreak = isAchFormat;
        this.textboxDirDepClassDesc.caption = isAchFormat ? "Class Description - PPD" : "Class Description";
    }

    enableCom(event: ChangeEvent){
        this.textboxEarningCode.required = this.switchEnableCommissions.checked;
    }

    textboxCompanyLimitMethodOnChange() {
        switch (this.textboxCompanyLimitMethod.selectedItem?.value) {
            case ("N"):
                this.textboxCompanyLimitAmount.enabled = false
                this.textboxCompanyLimitAmount.required = false
                this.textboxCompanyOrderPctLimit.enabled = false
                this.textboxCompanyOrderPctLimit.required = false
                break;
            case ("F"):
                this.textboxCompanyLimitAmount.enabled = true
                this.textboxCompanyLimitAmount.required = true
                this.textboxCompanyOrderPctLimit.enabled = false
                this.textboxCompanyOrderPctLimit.required = false
                break;
            case ("P"):
                this.textboxCompanyLimitAmount.enabled = false
                this.textboxCompanyLimitAmount.required = false
                this.textboxCompanyOrderPctLimit.enabled = true
                this.textboxCompanyOrderPctLimit.required = true
                break;
            case ("T"):
                this.textboxCompanyLimitAmount.enabled = false
                this.textboxCompanyLimitAmount.required = false
                this.textboxCompanyOrderPctLimit.enabled = true
                this.textboxCompanyOrderPctLimit.required = true
                break;
            default:
                this.textboxCompanyLimitAmount.enabled = false
                this.textboxCompanyLimitAmount.required = false
                this.textboxCompanyOrderPctLimit.enabled = false
                this.textboxCompanyOrderPctLimit.required = false
        }
    }

    textboxOwneropLimitMethodOnChange() {
        switch (this.textboxOwneropLimitMethod.selectedItem?.value) {
            case ("N"):
                this.textboxOwneropLimitAmount.enabled = false
                this.textboxOwneropLimitAmount.required = false
                this.textboxOwneropOrderPctLimit.enabled = false
                this.textboxOwneropOrderPctLimit.required = false
                break;
            case ("F"):
                this.textboxOwneropLimitAmount.enabled = true
                this.textboxOwneropLimitAmount.required = true
                this.textboxOwneropOrderPctLimit.enabled = false
                this.textboxOwneropOrderPctLimit.required = false
                break;
            case ("P"):
                this.textboxOwneropLimitAmount.enabled = false
                this.textboxOwneropLimitAmount.required = false
                this.textboxOwneropOrderPctLimit.enabled = true
                this.textboxOwneropOrderPctLimit.required = true
                break;
            case ("T"):
                this.textboxOwneropLimitAmount.enabled = false
                this.textboxOwneropLimitAmount.required = false
                this.textboxOwneropOrderPctLimit.enabled = true
                this.textboxOwneropOrderPctLimit.required = true
                break;
            default:
                this.textboxCompanyLimitAmount.enabled = false
                this.textboxCompanyLimitAmount.required = false
                this.textboxOwneropOrderPctLimit.enabled = false
                this.textboxOwneropOrderPctLimit.required = false
        }
    }

    textboxCarrierLimitMethodOnChange() {
        switch (this.textboxCarrierLimitMethod.selectedItem?.value) {
            case ("N"):
                this.textboxCarrierLimitAmount.enabled = false
                this.textboxCarrierLimitAmount.required = false
                this.textboxCarrierOrderPctLimit.enabled = false
                this.textboxCarrierOrderPctLimit.required = false
                break;
            case ("F"):
                this.textboxCarrierLimitAmount.enabled = true
                this.textboxCarrierLimitAmount.required = true
                this.textboxCarrierOrderPctLimit.enabled = false
                this.textboxCarrierOrderPctLimit.required = false
                break;
            case ("P"):
                this.textboxCarrierLimitAmount.enabled = false
                this.textboxCarrierLimitAmount.required = false
                this.textboxCarrierOrderPctLimit.enabled = true
                this.textboxCarrierOrderPctLimit.required = true
                break;
            case ("T"):
                this.textboxCarrierLimitAmount.enabled = false
                this.textboxCarrierLimitAmount.required = false
                this.textboxCarrierOrderPctLimit.enabled = true
                this.textboxCarrierOrderPctLimit.required = true
                break;
            default:
                this.textboxCarrierLimitAmount.enabled = false
                this.textboxCarrierLimitAmount.required = false
                this.textboxCarrierOrderPctLimit.enabled = false
                this.textboxCarrierOrderPctLimit.required = false
        }
    }
    textboxDirDepFormatOnChange() {
        const selectedFormat = this.textboxDirDepFormat.selectedItem?.value ?? this.activeRow.getString("dir_dep_format", "");
        switch (selectedFormat) {
            case ("A"):
                this.textboxOriginatorId.enabled = false
                this.textboxOriginatorId.required = false
                this.textboxCpaCode.enabled = false
                this.textboxCpaCode.required = false
                break;
            case ("B"):
                this.textboxOriginatorId.enabled = true
                this.textboxOriginatorId.required = true
                this.textboxCpaCode.enabled = true
                this.textboxCpaCode.required = true
                break;
            case ("E"):
                this.textboxOriginatorId.enabled = false
                this.textboxOriginatorId.required = false
                this.textboxCpaCode.enabled = false
                this.textboxCpaCode.required = false
                break;
            case ("T"):
                this.textboxOriginatorId.enabled = true
                this.textboxOriginatorId.required = true
                this.textboxCpaCode.enabled = true
                this.textboxCpaCode.required = true
                break;
            default:
                this.textboxOriginatorId.enabled = false
                this.textboxOriginatorId.required = false
                this.textboxCpaCode.enabled = false
                this.textboxCpaCode.required = false
        }
        this.updateClassDescriptionByFormat(selectedFormat);
    }


    /** This is an event handler for the beforeLookupModelSearch event of textboxEarningCode. */
    textboxEarningCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.code_type = "E";
    }

    async buttonUpdateYearOnClick(event: ClickEvent) {
        this.buttonUpdateYear.busy = true;
        const panel = new Panel();
        panel.add(new Label({
            text: "This program resets payee year-to-date (YTD) amounts based on history records dated within the selected year and updates the current processing year.",
            fontBold: true
        }));
        panel.add(new Label({
            text: "This action does not affect tax reporting for previously recorded history.",
            imageName: ImageName.triangleWarningSolid,
            imageColor: "warning"
        }));
        const textboxYear = new Textbox({
            caption: "Year",
            required: true,
            width: 100,
            displayType: DisplayType.INTEGER,
            minValue: 0
        });
        textboxYear.addlValidationCallback = (value: string) => {
            const result: ValidationResult = {
                isValid: true,
                component: textboxYear
            };
            // year must be 4 digits
            if (!/^\d{4}$/.test(value)) {
                result.isValid = false;
                result.validationMessage = "Year must be a 4-digit number.";
            }
            return result;
        };
        textboxYear.text = (this.activeRow.getNumber("current_process_year") + 1).toString();
        panel.add(textboxYear);
        const isYes = await CommonDialogs.showYesNo(panel, "Update Year", {
            yesButtonCaption: "Proceed",
            noButtonCaption: "Cancel",
            width: 500
        });
        if (isYes) {
            const snackbar = Snackbar.showDownloadSnackbar("Update Year", "Updating payee YTD totals for year " + textboxYear.text, { persist: true });
            try {
                const response = await Api.update("lme/settlement/update-payee-ytd-totals", {
                    start_date: "01/01/" + textboxYear.text,
                    end_date: "12/31/" + textboxYear.text
                });
                const data = response?.data?.[0];
                await this.mainDataSource.search(this.mainDataSource.lastSearch);
                if (data) {
                    const processedCount = data.records_processed;
                    const recordCount = data.record_count;
                    Toast.showSuccessToast(`${processedCount} out of ${recordCount} payees were updated successfully.`);
                }
            } finally {
                snackbar.dismiss();
            }
        }
        this.buttonUpdateYear.busy = false;
    }
}
